export const INITIAL_VALUE = {
  email: '',
  password: ''
};

export const DESCRIPTOR = {
  email: { type: 'email', required: true, message: 'Email is required' },
  password: {
    type: 'string',
    required: true,
    min: 8,
    max: 128,
    message: 'Must be at least 8 characters.'
  }
};
